import React from "react";
import "./mobile-tips-plug.scss";
import ShowContainer from "../../../../../mui/ShowContainer";
import ChatTips from "../../../../chat/ChatTips";
import ChatLovenseToys from "../../../../chat/lovense/ChatLovenseToys";
import { ENUM_CHAT_TAB } from "../../../../../common/enums";
import { useAppSelector } from "../../../../../../store/index.ts";
import IconCross from "../../../../../../images/jsIcons/IconCross.jsx";
import { useDispatch } from "react-redux";
import { setMobilePopupTips } from "../../../../../../store/chatSlice.js";
import useStreamStatus from "../../../../../../hooks/site/useStreamStatus.js";

export default function MobileTipsPlug() {
  const dispatch = useDispatch();
  const { isStream } = useStreamStatus();
  const isMobilePopupTips = useAppSelector((state) => state.chat.isMobilePopupTips);
  const isMobile = useAppSelector((state) => state.deviceSize.isMobile);
  // const height = useAppSelector((state) => state.deviceSize.height);
  // const zoomistHeight = useAppSelector((state) => state.siteInfo.blockHeight.zoomistHeight);

  // const tipsPlugHeight = height - zoomistHeight;

  return (
    <ShowContainer condition={isMobile && isMobilePopupTips && isStream}>
      <div
        className="mobile-tips__plug"
        // style={{
        //   maxHeight: tipsPlugHeight ? tipsPlugHeight + "px" : undefined,
        // }}
      >
        <button
          className="mobile-tips__plug__cross"
          onClick={() => dispatch(setMobilePopupTips(false))}
        >
          <IconCross />
        </button>

        <ShowContainer condition={isMobilePopupTips === ENUM_CHAT_TAB.tips}>
          <ChatTips />
        </ShowContainer>
        <ShowContainer condition={isMobilePopupTips === ENUM_CHAT_TAB.lovense}>
          <ChatLovenseToys />
        </ShowContainer>
      </div>
    </ShowContainer>
  );
}
